"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.targetSiteLink = void 0;
const apollo_link_1 = require("apollo-link");
const config_1 = require("../logic/config");
const auth_1 = require("../logic/auth");
const targetSiteLink = (config) => {
    const c = (0, config_1.mergeConfig)(config);
    return class extends apollo_link_1.ApolloLink {
        request(operation, forward) {
            const additionalHeaders = {
                'X-Target-Site': c.TARGET_SITE,
            };
            const token = (0, auth_1.getValidToken)();
            if (token) {
                additionalHeaders.authorization = token;
            }
            operation.setContext((context) => ({
                ...context,
                headers: {
                    ...context.headers,
                    ...additionalHeaders,
                },
            }));
            return forward(operation);
        }
    };
};
exports.targetSiteLink = targetSiteLink;
//# sourceMappingURL=targetSiteLink.js.map